import './Loader.scss'

export interface LoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'spinner' | 'dots' | 'pulse'
  fullScreen?: boolean
  text?: string
  className?: string
}

export const Loader = ({
  size = 'md',
  variant = 'spinner',
  fullScreen = false,
  text,
  className = '',
}: LoaderProps) => {
  const loaderContent = (
    <>
      <div className={`crif-loader crif-loader-${variant} crif-loader-${size} ${className}`}>
        {variant === 'spinner' && <div className="crif-spinner"></div>}

        {variant === 'dots' && (
          <div className="crif-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        )}

        {variant === 'pulse' && (
          <div className="crif-pulse">
            <span></span>
            <span></span>
            <span></span>
          </div>
        )}
      </div>

      {text && <p className="crif-loader-text">{text}</p>}
    </>
  )

  if (fullScreen) {
    return (
      <div className="crif-loader-fullscreen">
        <div className="crif-loader-content">{loaderContent}</div>
      </div>
    )
  }

  return <div className="crif-loader-container">{loaderContent}</div>
}

export default Loader
